<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">

      <div class="flex justify-between items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">{{ __('Job :id history', {id: job.id}) }}</h1>
        <div class="sm:ml-6">
          <inertia-link :disabled="!job.permissions.update" :href="route('carPosition.create', {job: job.id})" class="btn-primary">
            {{ __("Car location") }}
          </inertia-link>
        </div>
      </div>


      <div class="bg-white p-4 shadow-md mt-10 overflow-x-auto">
        <table class="min-w-md w-full" v-if="logs.data.length">
          <tr class="bg-gray-700 text-gray-100">
            <th class="p-4 w-10">{{ __("Id") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Description") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Causer") }}</th>
            <th class="p-4 text-left min-w-40">{{ __("Date") }}</th>
          </tr>

          <tr v-for="(log, index) in logs.data" :class="{'bg-gray-300': index%2 === 0}">
            <td class="p-4 w-10">{{ log.id }}</td>
            <td class="p-4 text-left min-w-40">{{ log.description }}</td>
            <td class="p-4 text-left min-w-40">{{ log.causer.name }}</td>
            <td class="p-4 text-left min-w-40">{{ log.created_at }}</td>
          </tr>
        </table>
        <div v-else>
          {{ __("No history at the moment...") }}
        </div>

        <pagination :links="logs.meta.links"/>
      </div>
    </div>
  </div>
</template>


<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';
  import JobMenu from "./JobMenu";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Job :id history", {id: this.job.id}),
      }
    },
    props: {
      job: Object,
      logs: Object,
    },
    components: {
      Layout,
      Pagination,
      Icon,
      JobMenu
    }
  }
</script>
